<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header icon="fas fa-globe" header="{{'Locations' | translate}}" [subHeader]="'View data for the selected period.' | translate" [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <statistics-date-picker
                (onApply)="updateDateRange()"
                [(date)]="date"
                dateRangeGroup="statistics"
                class="pull-right">
        </statistics-date-picker>
    </page-header-content>
</page-header>
<div class="ml-2 mb-2 font-size-1-1">
    <a [uiSref]="'base.customer.domain.statistics.visitors.locations.index'">All</a> > <a [uiSref]="'base.customer.domain.statistics.visitors.locations.index'">Country</a> > <span>{{countryName}}</span>
</div>
<div class="card panel-monsido-card">
    <div class="card-body">
        <mon-spinner [loading]="loading">
            <statistics-summary-general [startDate]="date.startDate"
                                        [endDate]="date.endDate"
                                        [country]="countryCode"
                                        [data]="summary"
                                        [useDataFromData]="true"
                                        [hidePageviews]="true">
            </statistics-summary-general>
            <div class="row my-6">
                <div class="col-48 chart-center">
                    <mon-chart-pie
                            [labels]="doughnutLabels"
                            [data]="doughnutData"
                            [options]="doughnutOptions">
                    </mon-chart-pie>
                </div>
            </div>
            <table class="table table-hover">
                <thead>
                <tr>
                    <th class="col-sm-3 col-md-3" translate>Name</th>
                    <th class="col-sm-3 col-md-3 text-center">
                        <span translate>Visits</span><br>
                        <span class="text-grey">({{summary.visits | monNumber}})</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-center">
                        <span translate>Bounce rate</span><br>
                        <span class="text-grey">({{summary.bounce_rate}})</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-right">
                        <span translate>Actions per visit</span><br>
                        <span class="text-grey">({{summary.avg_actions}})</span>
                    </th>
                    <th class="col-sm-2 col-md-2 text-right">
                        <span translate>Average time</span><br>
                        <span class="text-grey">({{summary.avg_time | monNumber:'00:00:00'}})</span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let page of pages">
                    <td class="text-v-middle"><a [uiSref]="'base.customer.domain.statistics.visitors.locations.cities'" [uiParams]="{countryCode: page.country_code, countryName: page.country_name, regionCode: page.region_code, regionName: page.label}">{{page.label}}</a></td>
                    <td class="text-v-middle"><statistics-visits [visits]="page.visits" [totalVisits]="totalVisits"></statistics-visits></td>
                    <td class="text-v-middle text-center">{{page.bounce_rate / page.visits | monNumber:'0.[00]%'}}</td>
                    <td class="text-v-middle text-right">{{page.actions / page.visits | monNumber:'0.[00]'}}</td>
                    <td class="text-v-middle text-right">{{page.avg_time / page.visits | monNumber:'00:00:00'}}</td>
                </tr>
                </tbody>
            </table>
        </mon-spinner>
    </div>
</div>